import { Link } from "react-router-dom";
import { getWhatsAppLink } from "../../../utils/whatsapp";
import "./AppButton.css";

function isExternalHref(href = "") {
  return href.startsWith("http://") || href.startsWith("https://") || href.startsWith("mailto:") || href.startsWith("tel:");
}

export default function AppButton({
  children,
  label,
  to,
  href,
  whatsappKey,
  whatsappMessage,
  variant = "primary",
  size = "md",
  icon: Icon,
  iconRight: IconRight,
  className = "",
  external,
  ...props
}) {
  const content = children || label;
  const resolvedHref = href || (whatsappKey || whatsappMessage ? getWhatsAppLink(whatsappMessage || whatsappKey) : undefined);
  const classes = [
    "app-button",
    `app-button--${variant}`,
    `app-button--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const innerContent = (
    <>
      {Icon && <Icon className="app-button__icon" aria-hidden="true" />}
      <span>{content}</span>
      {IconRight && <IconRight className="app-button__icon app-button__icon--right" aria-hidden="true" />}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {innerContent}
      </Link>
    );
  }

  return (
    <a
      href={resolvedHref || "#"}
      className={classes}
      target={external === false || !isExternalHref(resolvedHref) ? undefined : "_blank"}
      rel={external === false || !isExternalHref(resolvedHref) ? undefined : "noreferrer"}
      {...props}
    >
      {innerContent}
    </a>
  );
}
